exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".input-group .input-group-addon:first-child,.input-group .input-group-addon:last-child{width:8em}.btn-brand.disabled.success{background-color:#1d8934;color:#eee}body.success{background-color:#fff}.successText{color:#000;font-size:18px;text-indent:50px}.reasonText{font-style:italic}.hero-unit.hero-unit-full.success{background-color:#efefef;padding-block-start:50em}.successHeaderText{font-size:18px;color:#fff}.successHeader{color:#fff;font-size:2.5em;font-weight:600}.hero-unit.success{background-color:#7d55aa;font-family:Futura,Trebuchet MS,Arial,sans-serif}html{background-color:#efefef}", ""]);

// exports



/*****************
 ** WEBPACK FOOTER
 ** ./~/css-loader!./src/app/Success/success.component.css
 ** module id = 380
 ** module chunks = 0
 **/